/**
 * Stub for react-native
 * Used when building for web to prevent webpack from trying to resolve React Native modules
 */

// Export a minimal Platform object
const Platform = {
  OS: 'web',
  Version: null,
  select: (obj) => obj.web || obj.default,
};

module.exports = {
  Platform,
};

